import { locales, type Locale } from "@/i18n/routing";

const DEFAULT_MARKETING_HOSTS = ["rivetai.com", "www.rivetai.com"] as const;

const parseAllowedHosts = (value: string | undefined): string[] => {
  if (!value?.trim()) {
    return [...DEFAULT_MARKETING_HOSTS];
  }

  return value
    .split(",")
    .map((host) => host.trim())
    .filter(Boolean);
};

export const getMarketingAnalyticsAllowedHosts = (): string[] =>
  parseAllowedHosts(process.env.NEXT_PUBLIC_POSTHOG_ALLOWED_HOSTS);

export const isMarketingAnalyticsHostAllowed = (host?: string): boolean => {
  const currentHost =
    host ?? (typeof window !== "undefined" ? window.location.host : "");
  if (!currentHost) {
    return false;
  }

  if (process.env.NODE_ENV === "development") {
    return true;
  }

  const allowedHosts = getMarketingAnalyticsAllowedHosts();
  return allowedHosts.some(
    (allowedHost) =>
      currentHost === allowedHost || currentHost.endsWith(`.${allowedHost}`),
  );
};

export const extractPageLocale = (pathname: string): Locale | null => {
  const firstSegment = pathname.split("/").filter(Boolean)[0];
  return locales.includes(firstSegment as Locale)
    ? (firstSegment as Locale)
    : null;
};

export const buildCanonicalMarketingPagePath = (pathname: string): string => {
  const locale = extractPageLocale(pathname);
  if (!locale) {
    return pathname || "/";
  }

  const withoutLocale = pathname.replace(new RegExp(`^/${locale}(?=/|$)`), "");
  return withoutLocale === "" ? "/" : withoutLocale;
};
